import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/header/header";
import CardQuick from "../components/dashboard/CardQuick";
import DailyInvitations from "../components/dashboard/daily-invitations";
import DailyEvents from "../components/dashboard/daily-events";
import Incidents from "../components/dashboard/incidents";
import { Consumer } from "../context";
import moment from "moment";
import "moment/min/locales";
import DinamicModal from "../components/dinamicModal/dinamicModal";
import Request from "../core/httpClient";
import Paginador from "../components/paginador/paginador";
import Map from "../components/maps/map";

const request = new Request();

function DashBoard(props) {

    const { context } = props;

    const [noInvitaciones, setNoInvitaciones] = useState(0);
    const [noActivas, setNoActivas] = useState(0);
    const [noIncidentes, setNoIncidentes] = useState(0);
    const [invitacionesDiarias, setInvitacionesDiarias] = useState([]);
    const [invitacionesActivas, setInvitacionesActivas] = useState([]);
    const [incidenciasDIa, setIncidenciasDIa] = useState(0);
    const [totalViviendas, setTotalViviendas] = useState(0);
    const [direccion, setDireccion] = useState(0);
    const [fraccionamiento, setFraccionamiento] = useState([{ id_fraccionamiento: 0, p_latitude: "", p_longitude: "" }]);
    const [loadViewMap, setLoadViewMap] = useState(false);
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [loadingViviendas, setLoadingViviendas] = useState(false);
    const [loadingIncidencias, setLoadingIncidencias] = useState(false);
    const [loadingDiarios, setLoadingDiarios] = useState(false);
    const [loadingActivos, setLoadingActivos] = useState(false);
    const [autorizaciones, setAutorizaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [idFracc, setIdFracc] = useState(0);
    const [bitacora, setBitacora] = useState([]);
    const [page, setPage] = useState(1);

    useEffect(() => {

        (async () => {

            const { fracActual } = context;

            if (fracActual != idFracc) {
                setIdFracc(fracActual);
            };

        })();

    }, [context.fracActual]);

    useEffect(() => {

        (async () => {

            if (idFracc > 0) {

                await getDashboard(idFracc);
                await getFraccionamiento(idFracc);

            };

        })();

    }, [idFracc]);

    const getDashboard = async (idFraccionamiento) => {

        setLoadingDiarios(true);
        setLoadingActivos(true);
        setLoadingIncidencias(true);
        setLoadingViviendas(true);
        setLoadingEvents(true);

        if (!idFraccionamiento) {

            setLoadingDiarios(false);
            setLoadingActivos(false);
            setLoadingIncidencias(false);
            setLoadingViviendas(false);
            setLoadingEvents(false);

            return;
        };

        const fechaHoy = moment(Date.now()).format("YYYY-MM-DD");
        const fechaInc = moment(Date.now()).format("MM-DD-YYYY");

        try {

            const [invDiariaRes, invActivasRes, incRes, cardsRes, dirRes, authRes] = await Promise.all([
                request.post("/invitaciones/get/panelentradas", { IdFraccionamiento: idFraccionamiento, Fecha: fechaHoy }),
                request.post("/invitaciones/get/panelsalidas", { IdFraccionamiento: idFraccionamiento, Fecha: fechaHoy }),
                request.post("/incidencias/get/panelincidentes", { IdFraccionamiento: idFraccionamiento, Fecha: fechaInc }),
                request.post("/invitaciones/get/panelcards", { IdFraccionamiento: idFraccionamiento, Fecha: fechaHoy }),
                request.get(`/fraccionamientos/direccion/${parseInt(idFraccionamiento)}`),
                request.post("/autorizaciones/get/dashboard", { IdFraccionamiento: idFraccionamiento, fecha: fechaHoy, tipo: 0 }),
            ]);

            setInvitacionesDiarias(invDiariaRes.invitaciones || []);
            setLoadingDiarios(false);

            setInvitacionesActivas(invActivasRes.activas || []);
            setLoadingActivos(false);

            setIncidenciasDIa(incRes.incidentes || []);
            setLoadingIncidencias(false);

            setNoInvitaciones(cardsRes[0]?.cantidad || 0);
            setNoActivas(cardsRes[1]?.cantidad || 0);

            setTotalViviendas(cardsRes[2]?.cantidad || 0);
            setLoadingViviendas(false);

            setNoIncidentes(cardsRes[3]?.cantidad || 0);

            setDireccion(dirRes.fraccionamientoDireccion || {});

            setAutorizaciones(authRes.autorizaciones || []);

            setLoadingEvents(false);

        } catch (e) {

            setLoadingDiarios(false);
            setLoadingActivos(false);
            setLoadingIncidencias(false);
            setLoadingViviendas(false);
            setLoadingEvents(false);

            console.error(e);
        };

    };

    const getFraccionamiento = async (idFraccionamiento) => {
        try {

            setLoadViewMap(false);

            const data = { IdFraccionamiento: idFraccionamiento };

            const response = await request.post("/admin/administracion/get/fraccionamiento", data);

            if (response && !response.error) {

                if (response.fraccionamiento && !response.empty) {

                    const f = response.fraccionamiento[0];

                    const lat = parseFloat(f.p_latitude);
                    const lng = parseFloat(f.p_longitude);

                    if (Number.isFinite(lat) && Number.isFinite(lng)) {
                        setFraccionamiento([{ ...f, p_latitude: lat, p_longitude: lng }]);
                    };
                };
            };

            setLoadViewMap(true);

        } catch (error) {
            setLoadViewMap(true);
            console.log(error);
        };
    };

    const openBitacora = async () => {

        setBitacora([]);

        const modal = document.getElementById("bitacoraModal");

        if (modal) {
            modal.classList.remove("hide-dinamic-modal");
            modal.classList.add("show-dinamic-modal");
        };

        await getRondas();
    };

    const getRondas = async () => {

        try {

            if (idFracc === 0) return;

            setLoading(true);

            const data = { IdFraccionamiento: idFracc };

            const response = await request.post("/incidencias/get/bitacora", data);

            if (response && !response.error) {

                if (response.data && !response.empty) {

                    setBitacora(response.data);

                } else {

                    setLoading(false);
                    setBitacora([]);
                }
            } else {

                setLoading(false);

            };

            setLoading(false);

        } catch (error) {
            console.log(error);
        };
    };

    const Reload = async () => {

        if (idFracc === 0) return;

        setLoadingActivos(true);

        const fechaHoy = moment(Date.now()).format("YYYY-MM-DD");

        try {

            const [invActivasRes, cardsRes] = await Promise.all([
                request.post("/invitaciones/get/panelsalidas", { IdFraccionamiento: idFracc, Fecha: fechaHoy }),
                request.post("/invitaciones/get/panelcards", { IdFraccionamiento: idFracc, Fecha: fechaHoy })
            ]);

            setInvitacionesActivas(invActivasRes.activas || []);
            setNoActivas(cardsRes[1]?.cantidad || 0);

            setLoadingActivos(false);


        } catch (e) {

            setLoadingActivos(false);

            console.error(e);
        };

    };

    return (
        <div className="dashboard column">
            <Helmet>
                <title>{process.env.REACT_APP_NAME} - Tablero</title>
            </Helmet>
            <Header />
            <div className="row">
                <div className="justify-center">
                    <div className="container column">
                        <div className="white-space-16" />
                        <div className="navigation align-center justify-end">
                            <button
                                type="button"
                                className="btn btn-primary btn-small color-white"
                                onClick={openBitacora}
                            >
                                <i className="fas fa-clipboard-list font-text" />
                                &nbsp; Bitácora
                            </button>
                        </div>
                        <div className="white-space-16" />
                        <div className="quick row">
                            <CardQuick
                                icon="warehouse"
                                value={totalViviendas}
                                loading={loadingViviendas ? true : false}
                                description="N° de viviendas"
                            />
                            <CardQuick
                                icon="exclamation-triangle"
                                value={noIncidentes}
                                loading={loadingIncidencias ? true : false}
                                description="N° de incidencias del día"
                            />
                            <CardQuick
                                icon="id-card"
                                value={noInvitaciones}
                                loading={loadingDiarios ? true : false}
                                description="N° de invitaciones pendientes"
                            />
                            <CardQuick
                                icon="user-friends"
                                value={noActivas}
                                loading={loadingActivos ? true : false}
                                description="Invitados en el fraccionamiento"
                            />
                        </div>
                        <div className="white-space-24" />
                        <DailyInvitations
                            dataDiaria={invitacionesDiarias}
                            dataActiva={invitacionesActivas}
                            loadingActivos={loadingActivos}
                            reload={Reload}
                        />
                        <div className="white-space-24" />
                        <DailyEvents
                            dataAuth={autorizaciones}
                            loadingEvents={loadingEvents}
                        />
                        <div className="row justify-between align-center">
                            <div className="row">
                                <DinamicModal
                                    idModal={"bitacoraModal"}
                                    sizeModalContainer={"big"}
                                    title={"BITÁCORA DE SEGURIDAD"}
                                    loadingSave={loading}
                                >
                                    <RenderBitacora
                                        bitacora={bitacora}
                                        page={page}
                                        setPage={setPage}
                                    />
                                </DinamicModal>
                            </div>
                        </div>
                        <div className="white-space-24" />

                        <Incidents incidentesHoy={incidenciasDIa} />

                        <div className="white-space-24" />
                        <h3 className="weight-semi">Información General</h3>
                        <div className="white-space-8" />

                        <p className="font-small">{direccion.complete}</p>

                        <div className="white-space-16" />

                        {(() => {

                            const hasFrac = fraccionamiento[0] && fraccionamiento[0].p_latitude !== "";
                            const src = hasFrac ? fraccionamiento[0] : { id_fraccionamiento: 0, p_latitude: "19.4284700", p_longitude: "-99.1276600" };
                            const lat = parseFloat(src.p_latitude);
                            const lng = parseFloat(src.p_longitude);
                            const key = `${lat},${lng}`;
                            const center = Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : undefined;

                            return loadViewMap ?
                                <Map key={key} data={src} center={center} />
                                :
                                null;

                        })()}

                        <div className="white-space-24" />
                    </div>
                </div>
            </div>
        </div>
    );
};

function RenderBitacora(props) {

    const { bitacora, page, setPage } = props;

    return (
        <div className="card-table card-owners column" id="card-owners">
            <div className="row">
                <table className="full">
                    <thead>
                        <tr className="text-left">
                            <th className="text-left">Usuario</th>
                            <th className="text-left">Fecha</th>
                            <th className="text-left">Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bitacora.slice((page - 1) * 7, page * 7).map((bit, key) => (
                            <React.Fragment key={key}>
                                <tr>
                                    <td className="text-left">{bit.usuario}</td>
                                    <td className="text-left">
                                        {moment(bit.fecha).tz("GMT").format("DD/MM/YYYY")}
                                    </td>
                                    <td className="text-left">
                                        <p className="">{bit.comentarios}</p>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="white-space-24" />
            <Paginador
                pages={Math.ceil(bitacora.length / 7)}
                setPage={setPage}
            />
        </div>
    );
};

export default Consumer(DashBoard);